import { Navigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import { useAuth } from 'hooks/login/useAuth';
import NavigationScroll from 'layout/navigationScroll';

const PrivateRoute = ({ children }: any) => {
    const auth = useAuth();
    const location = useLocation();
    if (!auth) {
        return <Navigate to='/' state={{ from: location }} />;
    }
    return <NavigationScroll>{children}</NavigationScroll>;
};
export default PrivateRoute;
